var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDCMS.setupProductDrivers = function () {
    
        var $productDrivers = $('.' + CSSCONSTANTS.productDriverClass);

        enquire.register(CSSCONSTANTS.mobileMaxWidthMQ, {
            match: function () {
                $.each($productDrivers, function () {
                    var $this = $(this);
                    CONFUSEDCMS.createProductDriver($this, 'mobile');
                });
            },
            unmatch: function () {
                $.each($productDrivers, function () {
                    var $this = $(this);
                    CONFUSEDCMS.createProductDriver($this, 'nonMobile');
                });
            }
        });
    };

    CONFUSEDCMS.createProductDriver = function ($this, screenSize) {
        var $notesTarget,
            backgroundImage,
            $productImage = $this.find('.product-driver__image'),
            $productNotes = $this.find('.product-driver__notes');

        if (screenSize === 'mobile') {
            $notesTarget = $this.find('.product-driver__link');
            backgroundImage = $productImage.attr('data-productMobileImage');
        }
        else if (screenSize === 'nonMobile') {
            $notesTarget = $this;
            backgroundImage = $productImage.attr('data-productDesktopImage');
        }

        $productImage.css('backgroundImage', 'url(' + backgroundImage + ')');
        $productNotes.appendTo($notesTarget);

    };

})(window.jQuery);


